import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, FileTextIcon, ListChecksIcon, TrendingUpIcon, AlertCircleIcon, CalendarIcon, ClipboardIcon } from 'lucide-react';
export function IncludesSection() {
  const includes = [{
    icon: FileTextIcon,
    title: 'El método completo paso a paso',
    description: 'Para cachorros y perros adultos'
  }, {
    icon: ListChecksIcon,
    title: 'Checklist de "Zona Segura"',
    description: 'Sin jaula obligatoria'
  }, {
    icon: TrendingUpIcon,
    title: 'Plantilla de Escalera de Ausencias',
    description: 'Niveles listos para usar'
  }, {
    icon: AlertCircleIcon,
    title: 'Protocolo "qué hago si llora"',
    description: 'Para no romper el avance'
  }, {
    icon: CalendarIcon,
    title: 'Plan rápido de 7 días + plan sólido de 21 días',
    description: 'Elige según tu situación'
  }, {
    icon: ClipboardIcon,
    title: 'Tracker imprimible',
    description: 'Para notas del celular o papel'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0
    }
  };
  return <section className="w-full bg-[#F5F3F0] py-16 md:py-24 px-4" data-id="element-67">
      <div className="max-w-6xl mx-auto" data-id="element-68">
        <motion.h2 className="text-3xl md:text-4xl font-bold text-[#2C2C2C] mb-12 text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-69">
          Qué incluye
        </motion.h2>

        <motion.div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} data-id="element-70">
          {includes.map((item, index) => {
          const Icon = item.icon;
          return <motion.div key={index} className="bg-white rounded-xl p-6" variants={itemVariants} data-id="element-71">
                <div className="flex items-start mb-4" data-id="element-72">
                  <div className="flex-shrink-0 w-12 h-12 bg-[#C7E0E7]/10 rounded-lg flex items-center justify-center mr-4" data-id="element-73">
                    <Icon className="h-6 w-6 text-[#C7E0E7]" aria-hidden="true" data-id="element-74" />
                  </div>
                  <div data-id="element-75">
                    <h3 className="text-lg font-bold text-[#2C2C2C] mb-2" data-id="element-76">
                      {item.title}
                    </h3>
                    <p className="text-[#5C5C5C] text-sm" data-id="element-77">{item.description}</p>
                  </div>
                </div>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}